import { render, staticRenderFns } from "./newGroup.vue?vue&type=template&id=1c4758e7&"
import script from "./newGroup.vue?vue&type=script&lang=js&"
export * from "./newGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports